import React, { useState } from 'react';
import { Box, Slide } from '@mui/material';
import AuthTestKitActivationForm from './auth/AuthTestKitActivationForm';
import SuccessfulActivationOrRegistration from './guest/SuccessfulActivationOrRegistration';
import { TestKitActivationLastSteps } from '../../types/user';
import { useSearchParams } from 'react-router-dom';
import { useThemeContext } from '../../contexts/BaseThemeContextProvider';
import { TestKitActivationFormProps } from './MainTestKitActivation';

export default function AuthTestKitActivation({ disableTestKitActivation }: TestKitActivationFormProps) {
  const { theme } = useThemeContext();
  const [shopifyOrderId, setShopifyOrderId] = useState('');
  const [testKitStep, setTestKitStep] = useState('activationForm');
  const [finalStepsData, setFinalStepsData] = useState<TestKitActivationLastSteps>({} as TestKitActivationLastSteps);
  let [searchParams] = useSearchParams();
  const activationCodeValue = searchParams.get('activationCode') || '';

  const renderSuccessfulActivation = () => (
    <Box sx={{ paddingTop: '20px' }}>
      <SuccessfulActivationOrRegistration finalStepsData={finalStepsData} isGuest={false} />
    </Box>
  );

  return (
    <Box sx={theme.custom.components.authTestKitActivation.containerStyles}>
      <Slide
        direction="left"
        in={testKitStep === 'activationForm'}
        mountOnEnter
        unmountOnExit
        timeout={{ enter: 600, exit: 100 }}
      >
        <div>
          <AuthTestKitActivationForm
            activationCodeValue={activationCodeValue}
            setTestKitStep={setTestKitStep}
            setShopifyOrderId={setShopifyOrderId}
            setFinalStepsData={setFinalStepsData}
            disableTestKitActivation={disableTestKitActivation}
          />
        </div>
      </Slide>

      <Slide
        direction="left"
        in={testKitStep === 'activationSubmitSuccess'}
        mountOnEnter
        unmountOnExit
        timeout={{ enter: 600, exit: 100 }}
      >
        <div>{renderSuccessfulActivation()}</div>
      </Slide>
    </Box>
  );
}
